module.exports = __webpack_public_path__ + "static/media/Logo.088aa953.png";